import React from 'react';
import PropTypes from 'prop-types';

import { useStopActions } from './hooks/useStopActions';
import { createStopMenuItems } from './factories/stopActionsMenuFactory';
import { useStopActionsMenuPermissions } from './hooks/useStopActionsMenuPermissions';
import Shortcut from '../components/Shortcut';

/**
 * StopActionsMenu Component - Displays the shortcut menu for a stop
 *
 * @param {Object} props - Component props
 * @param {Object} props.stop - Stop data object
 * @param {number} props.routeId - ID of the route
 * @param {Function} props.toggleOrderAndItemsModal - Function to toggle orders and items modal
 * @param {boolean} props.allowArriveItem - Whether arrive action is allowed
 * @param {boolean} props.allowDepartStop - Whether depart action is allowed
 * @param {boolean} props.allowUndeliveryStop - Whether undelivery action is allowed
 * @returns {JSX.Element} Rendered component
 */
function StopActionsMenu({
  stop,
  routeId,
  toggleOrderAndItemsModal,
  allowArriveItem,
  allowDepartStop,
  allowUndeliveryStop,
  allowSeeOrdersAndItems
}) {
  const stopActions = useStopActions(stop, routeId);
  const permissions = useStopActionsMenuPermissions();

  const stopState = {
    allowArriveItem,
    allowDepartStop,
    allowUndeliveryStop,
    allowSeeOrdersAndItems
  };

  const shortcutMenus = createStopMenuItems(
    stopActions,
    toggleOrderAndItemsModal,
    permissions,
    stopState
  );

  return <Shortcut data={stop} menus={shortcutMenus} />;
}

StopActionsMenu.propTypes = {
  stop: PropTypes.object.isRequired,
  routeId: PropTypes.number.isRequired,
  toggleOrderAndItemsModal: PropTypes.func.isRequired,
  allowArriveItem: PropTypes.bool.isRequired,
  allowDepartStop: PropTypes.bool.isRequired,
  allowUndeliveryStop: PropTypes.bool.isRequired,
  allowSeeOrdersAndItems: PropTypes.bool.isRequired
};

export default StopActionsMenu;
